export const Preloaders = {
  SENDING_MESSAGE: 'SENDING_MESSAGE',
};

export const ApiEndpoints = {
  SENDING_MESSAGE: '/api/message/template',
};
